import { render, staticRenderFns } from "./TrainingRegistrationRoot.vue?vue&type=template&id=7a29e926&"
import script from "./TrainingRegistrationRoot.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistrationRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports